
import React, { useState } from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { MedewerkerFormValues } from "./types";

interface PasswordFieldProps {
  form: UseFormReturn<MedewerkerFormValues>;
  isEditMode: boolean;
}

const PasswordField = ({ form, isEditMode }: PasswordFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <FormField
      control={form.control}
      name="password"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{isEditMode ? "Nieuw wachtwoord" : "Wachtwoord"}</FormLabel>
          <FormControl>
            <div className="relative">
              <Input 
                {...field} 
                type={showPassword ? "text" : "password"} 
                placeholder={isEditMode ? "Leeg laten om ongewijzigd te houden" : "Wachtwoord"} 
              />
              <button 
                type="button"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </FormControl>
          {isEditMode && (
            <FormDescription>
              Laat leeg om het huidige wachtwoord te behouden
            </FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default PasswordField;
